import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from '@binance-chain/honeycomb'
import styled from 'styled-components'
import { em } from 'polished'
import { detect } from 'detect-browser'

import { useI18n } from '../../i18n/util'

import { ReactComponent as Sub } from './sub.svg'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Text = styled.p`
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced)};
  line-height: ${({ theme }) => em(theme.honeycomb.size.increased)};
  color: ${({ theme }) => theme.honeycomb.color.text.masked};
  margin-bottom: ${({ theme }) => em(theme.honeycomb.size.increased)};
  text-align: center;
`

const DownloadLink = styled.a`
  color: ${({ theme }) => theme.honeycomb.color.text.primary};
  padding: 0 5px;
`

const ContentTitle = styled.h1`
  font-size: ${em(16)};
  line-height: ${em(19)};
  margin-top: ${({ theme }) => em(theme.honeycomb.size.normal)};
  margin-bottom: ${({ theme }) => em(theme.honeycomb.size.small)};
`

const CheckInstallModal = ({ open, close }) => {
  const browser = detect()
  const { formatI18nText } = useI18n()

  const walletDownloadLink = useMemo(() => {
    switch (browser && browser.name) {
      case 'firefox':
        return 'https://addons.mozilla.org/en-GB/firefox/addon/binance-chain/'
      case 'chrome':
        return 'https://chrome.google.com/webstore/detail/binance-chain-wallet/fhbohimaelbohpjbbldcngcnapndodjp?utm_source=chrome-ntp-icon'
      default:
        return 'https://chrome.google.com/webstore/detail/binance-chain-wallet/fhbohimaelbohpjbbldcngcnapndodjp?utm_source=chrome-ntp-icon'
    }
  }, [browser])

  return (
    <Modal open={open} onClose={close}>
      <Modal.Header />
      <Modal.Content>
        <Container>
          <Sub />
          <ContentTitle>{formatI18nText('checkInstallModal.title')}</ContentTitle>
          <Text>
            {formatI18nText('checkInstallModal.text1')}
            <DownloadLink href={walletDownloadLink} target="blank">
              {formatI18nText('checkInstallModal.link')}
            </DownloadLink>
            {formatI18nText('checkInstallModal.text2')}
          </Text>
          <Button shape="fit" variant="primary" htmlTag="a" href={walletDownloadLink}>
            {formatI18nText('checkInstallModal.button.install')}
          </Button>
        </Container>
      </Modal.Content>
    </Modal>
  )
}

CheckInstallModal.propTypes = {
  open: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
}

export default CheckInstallModal
